module.exports = __webpack_public_path__ + "static/img/浙江大学附属第一医院.7f0cbac.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/浙江大学附属第一医院.png
// module id = jt9G
// module chunks = 0 1 2 9